import { NgModule } from "@angular/core";
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./layouts/layout.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { RegisterComponent } from "./modules/account/register/register.component";

const routerConfig: ExtraOptions = {
	preloadingStrategy: PreloadAllModules,
	scrollPositionRestoration: "enabled",
};

const routes: Routes = [
	{
		path: "",
		component: LayoutComponent,
		loadChildren: () => import("./modules/modules.module").then((m) => m.ModulesModule),
	},
	{
		path: "auth",
		loadChildren: () => import("./modules/account/account.module").then((m) => m.AccountModule),
	},
	
];

@NgModule({
	imports: [RouterModule.forRoot(routes, routerConfig)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
